import axios from 'axios';

// 创建一个 axios 实例
const apiClient = axios.create({
  baseURL:  process.env.VUE_APP_HTTP_API_URL || `${window.location.origin}`, // 基础 URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// 设置请求拦截器和响应拦截器（可选）
apiClient.interceptors.request.use(config => {
  // 在请求发送前做一些处理，例如添加 token
  const token = localStorage.getItem('ocs_user_token'); // 假设 token 存储在 localStorage 中
  if (token && token.length > 0) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const customerWebsiteUserToken = localStorage.getItem('customer_website_user_token');
  if (customerWebsiteUserToken && customerWebsiteUserToken.length > 0) {
    config.headers.customerWebsiteUserToken = customerWebsiteUserToken;
  }

  console.log('[API Request] <<<<', (config.method || '').toUpperCase(), (config.baseURL || '') + (config.url || ''), {
    params: config.params,
    data: config.data,
    headers: config.headers,
  });

  return config;
}, error => {
  // 处理请求错误
  console.error('[API Request Error]', error);
  return Promise.reject(error);
});

apiClient.interceptors.response.use(response => {
  // 处理响应数据
  console.log('[API Response] >>>>', (response.config.method || '').toUpperCase(), (response.config.baseURL || '') + (response.config.url || ''), {
    status: response.status,
    data: response.data,
  });
  return response;
}, error => {
  // 处理响应错误
  console.error('[API Response Error]', error.config && (error.config.baseURL || '') + (error.config.url || ''), {
    status: error.response && error.response.status,
    data: error.response && error.response.data,
    message: error.message,
  });
  return Promise.reject(error);
});

export default apiClient;
